import type { TCreateSlice } from "@/store";

type TStateDealOverview = {
    activeTab: number;
    deleteModalOpen: boolean;
};

type TActionsPublicDealOverview = {
    setActiveTab: (value: number) => void;
    setDeleteModalOpenState: (open: boolean) => void;
    resetDealOverviewState: () => void;
};

export type TSliceDealOverview = TStateDealOverview &
    TActionsPublicDealOverview;

export const initialStateDealOverview = {
    activeTab: 0,
    deleteModalOpen: false,
} as const satisfies TStateDealOverview;

export const createSliceDealOverview: TCreateSlice<TSliceDealOverview> =
    () => set => ({
        ...initialStateDealOverview,
        setActiveTab: step => {
            set({ activeTab: step }, false, "deals/setActiveTab");
        },
        setDeleteModalOpenState: open => {
            set(
                { deleteModalOpen: open },
                false,
                "deals/setDeleteModalOpenState",
            );
        },
        resetDealOverviewState: () => {
            set(
                initialStateDealOverview,
                false,
                "deals/resetDealOverviewState",
            );
        },
    });
